'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _settingTools = require('@/libs/settingTools');

var settingTools = _interopRequireWildcard(_settingTools);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filterString: ''
        };
    },
    computed: {
        filteredSettings: function filteredSettings() {
            var settings = this.settings;
            var filter = this.filterString.toLowerCase();
            var out = [];
            (0, _keys2.default)(settings).forEach(function (key) {
                var value = settings[key];
                if (value.key.toLowerCase().indexOf(filter) !== -1) {
                    out.push(value);
                }
            });
            return out;
        },
        settings: function settings() {
            var out = {};
            var base = [];
            settingTools.buildTree(out, base, this.$state.getSetting('settings'), false);
            settingTools.buildTree(out, base, this.$state.getSetting('user_settings'), true);

            return _lodash2.default.orderBy((0, _keys2.default)(out).map(function (key) {
                return out[key];
            }), [function (o) {
                return o.key.split('.').length - 1;
            }, 'key'], ['asc']);
        }
    },
    methods: {
        resetValue: function resetValue(event, settingKey) {
            var newVal = this.$state.getSetting('settings.' + settingKey);
            if (!newVal) {
                newVal = null;
            }
            this.$state.setting(settingKey, newVal);
        },
        updateSetting: function updateSetting(event, settingKey) {
            var target = event.target;
            var val = target.type === 'checkbox' ? target.checked : target.value;
            switch (target.type) {
                case 'checkbox':
                    val = target.checked;
                    break;
                case 'number':
                    val = parseInt(target.value, 10);
                    break;
                default:
                    val = target.value;
                    break;
            }
            if (this.$state.setting(settingKey) === val) {
                return;
            }

            this.$state.setting(settingKey, val);
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["SettingsAdvanced"]
window._kiwi_exports.components.SettingsAdvanced = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SettingsAdvanced.vue
// module id = exRi
// module chunks = 1